import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-attachment-modal',
	templateUrl: './attachment-modal.html'
})
export class AttachmentModalComponent {
	public refreshData: number;

	constructor(public dialogRef: MatDialogRef<AttachmentModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	setRefreshData(value): void {
		this.refreshData = value;
	}
}
